import { FC, useState } from 'react';
import { Payments } from './Payments';
import { Taxes } from './Taxes';
import { TabMenuFilter } from 'components/TabMenuFilter';
import { Deals } from './Deals';
import styles from './TabOperations.module.scss';

export const TabOperations: FC = () => {
  const [localActive, setActive] = useState<string>(
    localStorage.getItem('operationsFilter') || 'deals',
  );

  const content: Record<string, React.ReactNode> = {
    deals: <Deals title={localActive} />,
    payments: <Payments title={localActive} />,
    taxes: <Taxes />,
  };

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <div className={styles.root_headerItem}>
          <TabMenuFilter operations active={localActive} setActive={setActive} />
        </div>
      </div>
      <div className={styles.content}>{content[localActive]}</div>
    </div>
  );
};
